/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import styled from 'styled-components';
/**
 * Internal dependencies
 */
import useSidebar from './useSidebar';
import { getTabId } from './utils';

const SidebarPane = styled.div.attrs({ role: 'tabpanel' })`
  height: 100%;
  overflow: overlay;
`;

const SidebarPanes = styled.section`
  height: 100%;
`;

function Sidebar() {
  const { tab, tabs } = useSidebar(({ state: { tab }, data: { tabs } }) => ({
    tab,
    tabs,
  }));

  return (
    <SidebarPanes>
      {tabs.map(({ id, Pane }) => (
        <SidebarPane
          aria-labelledby={id}
          id={getTabId(id)}
          key={id}
          hidden={id !== tab}
        >
          {id === tab && <Pane />}
        </SidebarPane>
      ))}
    </SidebarPanes>
  );
}

export default Sidebar;
